export default __webpack_public_path__ + "static/media/cucumber-apple-salad.3a99d617.jpeg";